/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCardVisaLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 20" {...props}>
    <path
      fill="#1434CB"
      d="M19.629 6.112c-1.703 0-3.224.883-3.224 2.515 0 1.871 2.698 2 2.698 2.94 0 .397-.453.751-1.227.751-1.099 0-1.92-.495-1.92-.495l-.351 1.647s.946.418 2.201.418c1.862 0 3.326-.927 3.326-2.586 0-1.978-2.709-2.103-2.709-2.976 0-.31.372-.65 1.144-.65.87 0 1.581.36 1.581.36l.344-1.59s-.773-.334-1.864-.334Zm-15.576.12-.04.24s.715.131 1.36.393c.831.3.89.475 1.03 1.017l1.524 5.882h2.044l3.147-7.532H11.08l-2.023 5.121-.825-4.341c-.076-.497-.46-.78-.928-.78h-3.25Zm9.885 0-1.599 7.532h1.944l1.594-7.532h-1.939Zm10.843 0c-.47 0-.717.251-.9.69l-2.848 6.842h2.039l.394-1.14h2.484l.24 1.14h1.798L26.42 6.232h-1.638Zm.265 2.035.604 2.826h-1.619l1.015-2.826Z"
    />
  </svg>
);

export default SvgCardVisaLogo;
